import PromptBookAnonymous from "./PromptBookAnonymous";
import useIsLoggedIn from "hooks/user/useIsLoggedIn";
import { PromptSerializersPromptBook } from "types/serializers";
import PromptBookCurrentUser from "./PromptBookCurrentUser";

export interface Props {
  promptBook: PromptSerializersPromptBook;
}
export interface PromptBookCurrentUserProps {
  currentUserId?: number;
  answersCount: number;
}

export default function PromptBookVote({
  promptBook,
}: Props) {
  const loggedIn = useIsLoggedIn();

  if (loggedIn) {
    return (
      <PromptBookCurrentUser
        answersCount={promptBook.answersCount}
        promptBook={promptBook}
      />
    );
  }
  return <PromptBookAnonymous promptBook={promptBook} />;
}
